import type { FC, ReactNode } from 'react'

import { Dices, Gavel } from 'lucide-react'
import { SectionHeading } from '@/components/landing/section-heading'

const bidTypes = [
    {
        title: 'Lance livre',
        description: 'Você escolhe quanto quer ofertar. Os maiores percentuais da assembleia são contemplados.'
    },
    {
        title: 'Lance fixo',
        description: 'Percentual definido pela administradora. Se houver empate, vale o sorteio entre os participantes.'
    },
    {
        title: 'Lance embutido',
        description: 'Parte da própria carta de crédito, geralmente até 30%, vira lance sem tirar dinheiro do bolso.'
    },
    {
        title: 'FGTS no lance',
        description: 'No consórcio de imóveis residenciais, o saldo do FGTS pode compor o seu lance.'
    }
]

export const ContemplationSection: FC = (): ReactNode => {
    return (
        <section id='contemplacao' aria-labelledby='contemplacao-titulo' className='py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <div className='grid items-end gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16'>
                    <SectionHeading
                        id='contemplacao-titulo'
                        eyebrow='Contemplação'
                        title='Duas chances de ser contemplado todo mês'
                        description='Nas assembleias mensais, a administradora libera cartas de crédito por sorteio e por lance. Quem está com as parcelas em dia concorre sempre.'
                    />

                    <div className='grid gap-5 sm:grid-cols-2'>
                        <article className='rounded-[1.75rem] bg-ink p-7 text-primary-foreground sm:p-8'>
                            <span className='grid size-12 place-items-center rounded-2xl bg-gold text-gold-foreground'>
                                <Dices aria-hidden='true' className='size-6' />
                            </span>

                            <h3 className='mt-10 font-heading text-4xl leading-none'>
                                Sorteio
                            </h3>

                            <p className='mt-4 leading-relaxed text-primary-foreground/75'>
                                Todo participante em dia concorre. É a chance de ser contemplado pagando apenas as parcelas.
                            </p>
                        </article>

                        <article className='rounded-[1.75rem] bg-gold p-7 text-gold-foreground sm:p-8'>
                            <span className='grid size-12 place-items-center rounded-2xl bg-ink text-gold'>
                                <Gavel aria-hidden='true' className='size-6' />
                            </span>

                            <h3 className='mt-10 font-heading text-4xl leading-none'>
                                Lance
                            </h3>

                            <p className='mt-4 leading-relaxed text-gold-foreground/80'>
                                Você oferece um adiantamento de parcelas para antecipar a contemplação. Os maiores lances do mês são contemplados.
                            </p>
                        </article>
                    </div>
                </div>

                <div className='mt-16 border-t border-border pt-12'>
                    <h3 className='text-xs font-bold uppercase tracking-[0.22em] text-bronze'>
                        Formas de ofertar lance
                    </h3>

                    <ul className='mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
                        {bidTypes.map(item => (
                            <li key={item.title} className='rounded-[1.5rem] bg-card p-6 ring-1 ring-border'>
                                <p className='text-lg font-bold text-foreground'>
                                    {item.title}
                                </p>

                                <p className='mt-2 text-sm leading-relaxed text-muted-foreground'>
                                    {item.description}
                                </p>
                            </li>
                        ))}
                    </ul>

                    <p className='mt-6 text-sm text-muted-foreground'>
                        As formas de lance aceitas e os limites de cada uma variam conforme a administradora e o grupo.
                    </p>
                </div>
            </div>
        </section>
    )
}
